import "./styles.css";

import Alpine from "alpinejs";
import intersect from "@alpinejs/intersect";
import focus from "@alpinejs/focus";

import { registerNav } from "./alpine/nav";
import { registerReveal } from "./alpine/reveal";
import { registerSlider } from "./alpine/slider";
import { registerLightbox } from "./alpine/lightbox";
import { registerParallax } from "./alpine/parallax";
import { registerStrip } from "./alpine/strip";
import { registerSocialRail } from "./alpine/social-rail";

declare global {
  interface Window {
    Alpine: typeof Alpine;
  }
}

Alpine.plugin(intersect);
Alpine.plugin(focus);

registerNav(Alpine);
registerReveal(Alpine);
registerSlider(Alpine);
registerLightbox(Alpine);
registerParallax(Alpine);
registerStrip(Alpine);
registerSocialRail(Alpine);

window.Alpine = Alpine;
Alpine.start();
document.body.classList.add("js-ready");
